import { render, staticRenderFns } from "./GridSubsection.vue?vue&type=template&id=43fe175a&"
import script from "./GridSubsection.vue?vue&type=script&lang=ts&"
export * from "./GridSubsection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports